module.exports = __webpack_public_path__ + "static/media/feature-1-rate.db872a23.png";